module.exports = __webpack_public_path__ + "media/images/soar/operation_decision-df873b2ca007346d19747d4a94c02d92.png";